import axios from 'axios';

class Form extends React.Component {
  constructor(props) {
    super(props);

    let title_name = 'Namn'
    let title_email = 'E-post'
    let title_phone = 'Telefonnummer'
    let title_message = 'Ditt meddelande'
    let title_submit = 'Skicka'
    let thx_title = 'Tack för ditt mail'
    let thx_msg = 'Observera att bokningen inte är gjord förrän du fått ett bekräftelse-email från oss.'

    if (props.lang === 'en') {
      title_name = 'Name'
      title_email = 'Email'
      title_phone = 'Phone number'
      title_message = 'Your message'
      title_submit = 'Send'
      thx_title = 'Thank you for your message'
      thx_msg = 'Please note that the reservation is not complete until you have recieved an confirmation email from us.'
    }

    if (props.lang === 'fi') {
      title_name = 'Nimi'
      title_email = 'Sähköposti'
      title_phone = 'Puheli'
      title_message = 'Viesti'
      title_submit = 'Lähettää'
      thx_title = 'Thank you for your message'
      thx_msg = 'Please note that the reservation is not complete until you have recieved an confirmation email from us.'
    }

    this.state = {
      name: '',
      email: '',
      phone: '',
      message: '',
      lang: props.lang,
      submitted: props.submitted,
      submitted_name: props.name,
      title_name: title_name,
      title_email: title_email,
      title_phone: title_phone,
      title_message: title_message,
      title_submit: title_submit,
      thx_msg: thx_msg,
      thx_title:thx_title,
      error_name: false,
      error_email: false
    };


    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit (event) {
    if (!this.state.name) {
      event.preventDefault()
      this.setState({
        error_name: true
      })
    }

    if (!this.state.email || !this.validateEmail(this.state.email)) {
      event.preventDefault()
      this.setState({
        error_email: true
      })
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    return (
      <form action="https://formspree.io/info@anderssons.ax" method="POST" className="contact__form padding" onSubmit={ this.handleSubmit }>
        { this.state.submitted &&
          <div className="contact__form__sent wysiwyg">
            <h4>{this.state.thx_title}
              { this.state.submitted_name &&
                <span>, {this.state.submitted_name}</span>
              }
            </h4>
            <p>{this.state.thx_msg}</p>
          </div>
        }
        
        
        <div className="contact__form__item">
          <label className="contact__form__label" htmlFor="name">{this.state.title_name} *</label>
          <input
            className={`contact__form__input ${this.state.error_name ? `contact__form__input--error` : undefined}`}
            id="name"
            name="name"
            type="text"
            value={this.state.name}
            onChange={this.handleInputChange} />
        </div>

        <div className="contact__form__item">
          <label className="contact__form__label" htmlFor="email">{this.state.title_email} *</label>
          <input
            className={`contact__form__input ${this.state.error_email ? `contact__form__input--error` : undefined}`}
            id="email"
            name="email"
            type="mail"
            value={this.state.email}
            onChange={this.handleInputChange} />
        </div>

        <div className="contact__form__item">
          <label className="contact__form__label" htmlFor="phone">{this.state.title_phone}</label>
          <input
            className="contact__form__input"
            id="phone"
            name="phone"
            type="phone"
            value={this.state.phone}
            onChange={this.handleInputChange} />
        </div>

        <div className="contact__form__item">
          <label className="contact__form__label" htmlFor="message">{this.state.title_message}</label>
          <textarea
            className="contact__form__input contact__form__textarea"
            id="message"
            name="message"
            value={this.state.message}
            onChange={this.handleInputChange}
            ></textarea>

        </div>

        <input type="hidden" name="_next" value={`${window.location.href}?emailsent=1&name=${encodeURI(this.state.name)}`} />
        <input type="text" name="_gotcha" style={{ display: 'none' }}/>
        <input type="hidden" name="_language" value={this.state.lang} />

        <button type="submit" className="contact__form__submit">
          {this.state.title_submit}
        </button>

      </form>
    );
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scripts/components/Form.js